module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms_02_m_jp.31a11037b4351814e60c3d05db7427c8.png";